<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";

export default {
  page: {
    title: "Master",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      tData: {
        historyUpload: [
          {
            id: "1",
            time: "12 Sep 2022",
            name: "file.xls",
            status: 0,
            uploader: "Joni",
          },
          {
            id: "2",
            time: "12 Sep 2022",
            name: "file.xls",
            status: 1,
            uploader: "Joni",
          },
          {
            id: "3",
            time: "12 Sep 2022",
            name: "file.xls",
            status: 2,
            uploader: "Joni",
          },
          {
            id: "4",
            time: "12 Sep 2022",
            name: "file.xls",
            status: 0,
            uploader: "Joni",
          },
          {
            id: "5",
            time: "12 Sep 2022",
            name: "file.xls",
            status: 1,
            uploader: "Joni",
          },
        ],
      },
    };
  },
  computed: {
    /**
     * Total no. of records
     */

    rows() {
      return this.tData.historyUpload.length;
    },

    title() {
      return "Unggah";
    },
    items() {
      return [
        {
          text: this.$t("menuitems.masterData.text"),
        },
        {
          text: this.$t("menuitems.masterData.list.employee"),
        },
        {
          text: "Unggah",
        },
      ];
    },
    historyUpload() {
      return [
        {
          key: "time",
          label: "Waktu",
          sortable: true,
        },
        {
          key: "name",
          label: "Nama ",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "uploader",
          label: "Diunggah Oleh",
          sortable: true,
        },
      ];
    },
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>



<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <p class="mb-4">Halaman unggah data karyawan.</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            v-b-modal.modal-history-upload
            variant="outline-primary"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_file-text"></i> Riwayat Unggahan
          </b-button>
          <b-button
            @click="$router.push({ name: 'Master Employee Import' })"
            variant="primary"
            class="ms-2"
          >
            <i class="mc-fa icon-outline_upload"></i> Unggah Lagi
          </b-button>
          <b-button
            @click="$router.push({ name: 'Master Employee' })"
            variant="outline-primary"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t("global.back") }}
          </b-button>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="mc-upload">
          <div class="mc-upload-result mc-upload-result--success">
            <figure>
              <img src="@/assets/images/success-icon.png" alt />
            </figure>
            <h4 class="mc-upload-result__label">
              Unggah Data Karyawan Berhasil
            </h4>
            <ul class="mc-upload-result__detail">
              <li><b>5</b> Data Total</li>
              <li class="text-success"><b>5</b> Data Berhasil</li>
              <li class="text-danger"><b>5</b> Data Gagal</li>
            </ul>
          </div>
          <div
            class="mc-upload-result mc-upload-result--warning"
            style="display: none"
          >
            <figure>
              <img src="@/assets/images/warning-icon.png" alt />
            </figure>
            <h4 class="mc-upload-result__label">
              Unggah Data Karyawan Berhasil Sebagian
            </h4>
            <ul class="mc-upload-result__detail">
              <li><b>5</b> Data Total</li>
              <li class="text-success"><b>5</b> Data Berhasil</li>
              <li class="text-danger"><b>5</b> Data Gagal</li>
            </ul>
            <b-button variant="outline-primary" class=""
              ><i class="mc-fa icon-outline_download"></i> Unduh Data
              Gagal</b-button
            >
          </div>
          <div
            class="mc-upload-result mc-upload-result--error"
            style="display: none"
          >
            <figure>
              <img src="@/assets/images/alert-report-danger.png" alt />
            </figure>
            <h4 class="mc-upload-result__label">Unggah Data Karyawan Gagal</h4>
            <ul class="mc-upload-result__detail">
              <li><b>5</b> Data Total</li>
              <li class="text-success"><b>5</b> Data Berhasil</li>
              <li class="text-danger"><b>5</b> Data Gagal</li>
            </ul>
            <b-button variant="outline-primary" class=""
              ><i class="mc-fa icon-outline_download"></i> Unduh Data
              Gagal</b-button
            >
          </div>
        </div>
      </div>
    </div>

    <b-modal
      class="mc-modal"
      id="modal-history-upload"
      title="Riwayat Unggah"
      size="lg"
      centered
      scrollable
    >
      <div class="clearfix">
        <!-- Search -->
        <div class="float-end">
          <div class="mc-table-view">
            <div
              id="tickets-table_filter"
              class="dataTables_filter text-md-end"
            >
              <label
                class="d-inline-flex align-items-center mc-table-view__search"
              >
                <i class="mc-fa fas fa-search"></i>
                <b-form-input
                  v-model="filter"
                  type="search"
                  :placeholder="$t('global.search') + '...'"
                  class="ms-2"
                ></b-form-input>
              </label>
            </div>
          </div>
        </div>
        <!-- End search -->
      </div>

      <!-- Table -->
      <div class="table-responsive my-3 border border-1">
        <b-table
          small
          show-empty
          :fields="historyUpload"
          :items="tData.historyUpload"
          class="datatables"
          responsive="sm"
          sort-by="groupNameService"
          empty-table
          :empty-text="$t('global.emptyTable')"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(time)="data">
            <p class="my-0">
              {{ data.item.time }}
            </p>
            <p class="text-muted my-0">12.00</p>
          </template>

          <template #cell(status)="data">
            <span
              class="mc-status mc-status--green"
              v-if="data.item.status === 0"
            >
              Berhasil
            </span>
            <span
              class="mc-status mc-status--red"
              v-else-if="data.item.status === 1"
            >
              Gagal
            </span>
            <span
              class="mc-status mc-status--yellow"
              v-else-if="data.item.status === 2"
            >
              Berhasil Sebagian
            </span>
          </template>
        </b-table>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              {{ $t("global.show") }}
              <b-form-select
                class="form-select form-select-sm"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
              entri
            </label>
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="text-end">
            <b-button variant="outline-primary" @click="cancel()">
              Tutup
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>